import { resolveAlgoliaSearchIndex } from '@atlassian/mpac-utils';
export const getAlgoliaConfig = (algoliaConfig, enableV4SearchIndexFlagValue) => {
  const searchIndex = resolveAlgoliaSearchIndex(algoliaConfig.environment, enableV4SearchIndexFlagValue);
  return {
    algoliaApiKey: algoliaConfig.apiKey,
    algoliaAppId: algoliaConfig.applicationId,
    algoliaSearchIndex: searchIndex
  };
};